import router from '@/router';
import { dialogNames } from '@/components/common/dialogs/dialogNames';

function handleDialogClose(state, dialogName) {
  if (state.dialog?.open && state?.dialog?.component === dialogName) {
    state.dialog.open = false;
    state.dialog.component = '';
    state.dialog.data = {};
  }
}

export const Mutations = {
  coordinatorLinkStatus(state, status) {
    if (status.isLinkUp) {
      state.coordinatorLinkStatus.message = 'Link OK';
      state.coordinatorLinkStatus.isLinkUp = true;
      state.coordinatorLinkStatus.retries = 0;

      handleDialogClose(state, dialogNames.connectionLostDialog);
      handleDialogClose(state, dialogNames.backupDialog);
    } else {
      state.coordinatorLinkStatus.message = status.message;
      state.coordinatorLinkStatus.isLinkUp = false;
      state.coordinatorLinkStatus.retries += 1;
      const { name: routerName = '' } = router.currentRoute.value;
      if (!['login', 'licenseLocked', 'enterLicense'].includes(routerName)) {
        // In case we have more than 256 agents polling will fail,next polling call will be ok, so don't show error popup yet, only after 1 error
        if (state.coordinatorLinkStatus.retries >= 2 && !state.dialog.locked) {
          this.commit('main/openDialog', { component: dialogNames.connectionLostDialog, data: { grayBackground: true, width: 0, height: 0 } });
        }
      }
    }
  },

  pageSize(state, payload) {
    state.pageSize = payload;
  },
  setUserNotifications(state, newState) {
    state.userNotifications.notificationsArray = newState;
  },

  SET_LD_STATE(state, newState) {
    state.leftDrawer.state = newState;
  },

  RESIZE_GRID_ITEM(state, payload) {
    const item = state.dashboardLayout.layout.find(i => i.i === payload.i);
    if (item) {
      if (payload.h + payload.lh < item.mh) {
        item.h = item.mh;
      } else {
        item.h = payload.h;
      }
      item.w = payload.w;
    }
    window.localStorage.setItem('dashboardLayout', JSON.stringify(state.dashboardLayout.layout));
  },

  SET_LD_COMPONENT(state, payload) {
    state.leftDrawer.title = payload.title;
    state.leftDrawer.component = payload.component;
  },

  openDialog(state, payload) {
    if (state.dialog?.locked) {
      return;
    }
    state.dialog.open = true;
    state.dialog.component = payload.component;
    state.dialog.data = payload.data;
    state.dialog.locked = payload.data?.locked;
    state.dialog.width = Object.prototype.hasOwnProperty.call(payload.data, 'width') ? payload.data.width : 400;
    state.dialog.height = Object.prototype.hasOwnProperty.call(payload.data, 'height') ? payload.data.height : 500;
  },

  dialogState(state, payload) {
    if (state.dialog?.locked) {
      return;
    }
    state.dialog.open = payload;
  },

  closeAll(state) {
    state.dialog.open = false;
    state.dialog.locked = false;
    state.leftDrawer.open = false;
  },

  MOVE_WIDGET(state, payload) {
    const widget = state.dashboardLayout.layout.find(item => item.i === payload.i);
    widget.x = payload.x;
    widget.y = payload.y;
    window.localStorage.setItem('dashboardLayout', JSON.stringify(state.dashboardLayout.layout));
  },

  REMOVE_WIDGET(state, payload) {
    const removeIndex = state.dashboardLayout.layout.map(item => item.i).indexOf(payload);
    const removedWidgetName = state.dashboardLayout.layout.find(item => item.i === payload);
    state.dashboardLayout.layout.splice(removeIndex, 1);
    window.localStorage.setItem('dashboardLayout', JSON.stringify(state.dashboardLayout.layout));
    const setupWidget = state.dashboardLayout.setup.find(widget => widget.c === removedWidgetName.c);
    setupWidget.draggable = true;
    window.localStorage.setItem('dashboardWidgets', JSON.stringify(state.dashboardLayout.setup));
    if (state.dashboardLayout.layout.length === 0) {
      state.dashboardLayout.layout.push({
        x: 1,
        y: 0,
        w: 10,
        h: 16,
        i: '9999',
        c: 'chart-placeholder',
        s: 'chartPlaceholder',
        mh: 12,
        dataset: '',
      });
      window.localStorage.removeItem('dashboardLayout');
      window.localStorage.setItem('dashboardLayout', JSON.stringify(state.dashboardLayout.layout));
    }
  },

  ADD_WIDGET(state, payload) {
    // clone existing object and mutate it
    const newWidget = { ...state.dashboardLayout.layout[0] };

    // get the widget from the setup state
    const widgetToAdd = state.dashboardLayout.setup.find(widget => widget.i === payload.i);

    state.dashboardLayout.layout = state.dashboardLayout.layout.filter(item => item.i !== 'drop');

    if (state.dashboardLayout.layout.length === 1 && state.dashboardLayout.layout[0].s === 'chartPlaceholder') {
      state.dashboardLayout.layout.splice(0, 1);
    }

    const idx = Math.random() * 10000;
    widgetToAdd.i = `${idx}`;
    widgetToAdd.x = payload.x;
    widgetToAdd.y = payload.y;

    // so that we get the complete observer object of the grid-item
    Object.assign(newWidget, widgetToAdd);
    state.dashboardLayout.layout.push(newWidget);

    // save to local storage for persistence
    window.localStorage.setItem('dashboardLayout', JSON.stringify(state.dashboardLayout.layout));
    const setupWidget = state.dashboardLayout.setup.find(widget => widget.c === newWidget.c);
    setupWidget.draggable = false;
    window.localStorage.setItem('dashboardWidgets', JSON.stringify(state.dashboardLayout.setup));
  },

  INIT_LAYOUT(state, layout) {
    if (layout) {
      state.dashboardLayout.layout = JSON.parse(layout);
      if (window.localStorage.getItem('dashboardWidgets')) {
        state.dashboardLayout.setup = JSON.parse(window.localStorage.getItem('dashboardWidgets'));
      }
    }
  },
};
